import { jsx as n } from "react/jsx-runtime";
import { createStyles as m, ActionIcon as c } from "@mantine/core";
import { IconPlayerPauseFilled as d, IconPlayerPlayFilled as b } from "@tabler/icons-react";
import "../ProductTile/ProductTileSkeleton.js";
import { IconChevronRight as p } from "../Icon/icons/ChevronRight.js";
import { IconChevronLeft as C } from "../Icon/icons/ChevronLeft.js";
const l = m((e) => ({
  bannerCarouselChevron: {
    "&:active": {
      transform: "translateY(-50%)"
    },
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    borderRadius: "50%",
    [e.fn.smallerThan("sm")]: {
      "&:active": {
        transform: "translateY(0)"
      },
      alignItems: "center",
      display: "flex",
      position: "relative",
      top: 0,
      transform: "translateY(0)"
    }
  },
  bannerCarouselChevronNext: {
    right: "1.6rem",
    [e.fn.smallerThan("sm")]: {
      right: 0
    }
  },
  bannerCarouselChevronPrev: {
    left: "1.6rem",
    [e.fn.smallerThan("sm")]: {
      left: 0
    }
  },
  bannerCarouselControl: {
    "&:active": {
      transform: "translateY(0)"
    },
    marginRight: "2rem",
    [e.fn.smallerThan("sm")]: {
      left: "10px",
      position: "absolute"
    }
  },
  bannerCarouselDot: {
    "&:after": {
      border: "1px solid #ffffff",
      borderRadius: "50%",
      boxSizing: "border-box",
      content: '""',
      height: "8px",
      width: "8px"
    },
    alignItems: "center",
    appearance: "none",
    backgroundColor: "transparent",
    border: "0",
    cursor: "pointer",
    display: "flex",
    height: "24px",
    marginLeft: "8px",
    marginRight: "8px",
    padding: "0",
    textDecoration: "none",
    touchAction: "manipulation",
    width: "8px"
  },
  bannerCarouselDotSelected: {
    "&:after": {
      background: "#ffffff"
    }
  }
})), I = (e) => {
  const { classes: r, cx: t } = l(), { buttonSize: o, color: a = "dark", iconSize: i, isNext: s = !0, onClick: u, variant: f = "default" } = e;
  return n(c, { className: t(r.bannerCarouselChevron, {
    [r.bannerCarouselChevronNext]: s,
    [r.bannerCarouselChevronPrev]: !s
  }), color: a, size: o, variant: f, onClick: u, children: s ? n(p, { size: i }) : n(C, { size: i }) });
}, N = (e) => {
  const { classes: r, cx: t } = l(), { onClick: o, selected: a } = e;
  return n("button", { "data-testid": "banner-carousel-dot-button", className: t(r.bannerCarouselDot, { [r.bannerCarouselDotSelected]: a }), type: "button", onClick: o });
}, k = ({ buttonSize: e, iconSize: r, isPlay: t, onControlClick: o }) => {
  const { classes: a } = l();
  return n(c, { "data-testid": "banner-carousel-control-button", className: `${a.bannerCarouselControl} banner-carousel__control-${t ? "play" : "pause"}`, onClick: o, radius: "xl", variant: "default", size: e, children: t ? n(d, { size: r }) : n(b, { size: r }) });
};
export {
  N as DotButton,
  I as NavigationButton,
  k as PlayControlButton
};
